import { IconButton, Tooltip } from "@mui/material"
import "./SharieIcn.css"
import useTranslationSharie from "../../hooks/Language/useTranslation"

const Icn = (props) => {
  const t = useTranslationSharie()

  return (
    <Tooltip arrow title={t(props.tooltip)}>
      <span>
        <IconButton
          disabled={localStorage.getItem("guest") === "true" || props.disabled}
          className={props.className}
          sx={{ color: props.color }}
          onClick={props.onClick}
          aria-label={props.label}
        >
          {props.icon || props.avatar}
        </IconButton>
      </span>
    </Tooltip>
  )
}

export default Icn
